export class LoginParticipante  {

    constructor(
        public id?: number,
        public nome?: string,
        public dataNascimento?: Date,
        public cpf?: string,
        public role?: string,
        public senha?: string,
        public email?: string,
        public aptoVotar?: string,
        public token? : string,
        public login?: string,

    ) {
       
    }

 
}